import { render, staticRenderFns } from "./CameraNew.vue?vue&type=template&id=3c7c067e&scoped=true&"
import script from "./CameraNew.vue?vue&type=script&lang=js&"
export * from "./CameraNew.vue?vue&type=script&lang=js&"
import style0 from "./CameraNew.vue?vue&type=style&index=0&id=3c7c067e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c067e",
  null
  
)

export default component.exports